import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../api/client';

const fmtDate = (d) => d ? new Date(d).toLocaleDateString('ko-KR', { month:'2-digit', day:'2-digit' }) : '-';
const fmtAmt = (v) => v ? '₩' + Number(v).toLocaleString() : '-';

export default function DashboardPage() {
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const scope = sp.get('scope') === 'org' ? 'org' : 'personal';
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/dashboard?scope=${scope}`).then(d => { setData(d); setLoading(false); }).catch(() => setLoading(false));
  }, [scope]);

  if (loading) return <div style={{textAlign:'center',padding:60,color:'#94a3b8'}}>로딩 중...</div>;
  if (!data) return <div style={{textAlign:'center',padding:60,color:'#94a3b8'}}>데이터를 불러올 수 없습니다.</div>;

  const s = data.stats || {};
  const daysSince = (d) => { if (!d) return '-'; const diff = Math.floor((Date.now() - new Date(d).getTime()) / 86400000); return diff + '일'; };

  return (
    <div>
      {/* 견적현황 Stats */}
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">누적 견적</div><div className="stat-value">{Number(s.total||0).toLocaleString()}<span style={{fontSize:14,color:'#94a3b8'}}>건</span></div></div>
        <div className="stat-card"><div className="stat-label">오늘</div><div className="stat-value">{Number(s.today||0).toLocaleString()}<span style={{fontSize:14,color:'#94a3b8'}}>건</span></div></div>
        <div className="stat-card"><div className="stat-label">이번 주</div><div className="stat-value">{Number(s.this_week||0).toLocaleString()}<span style={{fontSize:14,color:'#94a3b8'}}>건</span></div></div>
        <div className="stat-card"><div className="stat-label">이번 달</div><div className="stat-value">{Number(s.this_month||0).toLocaleString()}<span style={{fontSize:14,color:'#94a3b8'}}>건</span></div></div>
        <div className="stat-card"><div className="stat-label">올해</div><div className="stat-value">{Number(s.this_year||0).toLocaleString()}<span style={{fontSize:14,color:'#94a3b8'}}>건</span></div></div>
      </div>

      <div className={scope==='org' ? '' : 'grid-2'}>
        {/* 최근 견적서 */}
        <div className="card">
          <div className="card-header">
            <div className="card-title">{scope==='org' ? '조직 최근 견적서' : '최근 견적서'}</div>
            <span className="clickable" style={{fontSize:12}} onClick={()=>navigate('/product-estimate')}>전체보기 →</span>
          </div>
          <div style={{overflowX:'auto'}}><table>
            <thead><tr><th>견적번호</th><th>수신처</th><th>사업명</th><th>금액</th><th>태그</th></tr></thead>
            <tbody>
              {(data.recentEstimates||[]).map(e=>(
                <tr key={e.id}>
                  <td><span className="clickable" onClick={()=>navigate(`/product-estimate/new?id=${e.id}`)}>{e.estimate_number||e.draft_id}</span></td>
                  <td>{e.receiver_company}</td>
                  <td>{e.project_name}</td>
                  <td className="text-right fw-bold">{fmtAmt(e.total_amount)}</td>
                  <td>{(e.tags||[]).map((t,i)=><span key={i} className="tag tag-gray" style={{marginRight:3}}>{t}</span>)}</td>
                </tr>
              ))}
              {(data.recentEstimates||[]).length===0 && <tr><td colSpan={5} style={{textAlign:'center',padding:20,color:'#94a3b8'}}>견적서가 없습니다.</td></tr>}
            </tbody>
          </table></div>
        </div>

        {/* 공유받은 견적서 — 개인 모드만 */}
        {scope==='personal' && (
        <div className="card">
          <div className="card-header"><div className="card-title">최근 공유받은 견적서</div></div>
          <div style={{overflowX:'auto'}}><table>
            <thead><tr><th>견적번호</th><th>작성자</th><th>수신처</th><th>권한</th><th>금액</th></tr></thead>
            <tbody>
              {(data.sharedEstimates||[]).map(e=>(
                <tr key={e.id}>
                  <td><span className="clickable" onClick={()=>navigate(`/product-estimate/new?id=${e.id}`)}>{e.estimate_number||e.draft_id}</span></td>
                  <td>{e.author_name}</td>
                  <td>{e.receiver_company}</td>
                  <td><span className={`badge ${e.permission_type==='edit'?'badge-blue':'badge-gray'}`}>{e.permission_type==='edit'?'편집':'열람'}</span></td>
                  <td className="text-right fw-bold">{fmtAmt(e.total_amount)}</td>
                </tr>
              ))}
              {(data.sharedEstimates||[]).length===0 && <tr><td colSpan={5} style={{textAlign:'center',padding:20,color:'#94a3b8'}}>공유받은 견적서가 없습니다.</td></tr>}
            </tbody>
          </table></div>
        </div>
        )}
      </div>

      {scope==='personal' && (
      <div className="grid-2" style={{marginTop:16}}>
        {/* 내 승인 요청 */}
        <div className="card">
          <div className="card-header"><div className="card-title">승인요청 견적서 (내가 요청한)</div></div>
          <div style={{overflowX:'auto'}}><table>
            <thead><tr><th>견적</th><th>수신처</th><th>사유</th><th>상태</th><th>요청일</th></tr></thead>
            <tbody>
              {(data.myApprovalRequests||[]).map(r=>(
                <tr key={r.id}>
                  <td><span className="clickable" onClick={()=>navigate(`/approvals`)}>{r.estimate_number||r.draft_id}</span></td>
                  <td>{r.receiver_company}</td>
                  <td style={{maxWidth:150,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{r.reason}</td>
                  <td>
                    <span className={`badge ${r.status==='pending'?'badge-yellow':r.status==='approved'?'badge-green':'badge-red'}`}>
                      {r.status==='pending'?'승인대기':r.status==='approved'?'승인완료':'반려'}
                    </span>
                    {r.reject_reason && <div className="text-muted" style={{fontSize:10,marginTop:2}}>{r.reject_reason}</div>}
                  </td>
                  <td>{fmtDate(r.requested_at)}</td>
                </tr>
              ))}
              {(data.myApprovalRequests||[]).length===0 && <tr><td colSpan={5} style={{textAlign:'center',padding:20,color:'#94a3b8'}}>요청한 건이 없습니다.</td></tr>}
            </tbody>
          </table></div>
        </div>

        {/* 승인대기 (내가 처리할 건) */}
        <div className="card">
          <div className="card-header">
            <div className="card-title">승인대기 (내가 처리할 건)</div>
            <span className="clickable" style={{fontSize:12}} onClick={()=>navigate('/approvals')}>전체보기 →</span>
          </div>
          <div style={{overflowX:'auto'}}><table>
            <thead><tr><th>견적</th><th>요청자</th><th>수신처</th><th>사유</th><th>요청일</th></tr></thead>
            <tbody>
              {(data.pendingApprovals||[]).map(r=>(
                <tr key={r.id}>
                  <td><span className="clickable" onClick={()=>navigate('/approvals')}>{r.estimate_number||r.draft_id}</span></td>
                  <td>{r.requester_name}</td>
                  <td>{r.receiver_company}</td>
                  <td style={{maxWidth:150,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{r.reason}</td>
                  <td>{fmtDate(r.requested_at)}</td>
                </tr>
              ))}
              {(data.pendingApprovals||[]).length===0 && <tr><td colSpan={5} style={{textAlign:'center',padding:20,color:'#94a3b8'}}>처리할 건이 없습니다.</td></tr>}
            </tbody>
          </table></div>
        </div>
      </div>
      )}

      <div className={scope==='org' ? '' : 'grid-2'} style={{marginTop:16}}>
        {/* 견적결과 미입력 */}
        <div className="card">
          <div className="card-header">
            <div className="card-title">{scope==='org' ? '조직 견적결과 미입력' : '견적결과 미입력'}</div>
            <span className="text-muted">수주/실주/DROP 결과 입력 필요</span>
          </div>
          <table>
            <thead><tr><th>견적번호</th><th>수신처</th><th>사업명</th><th>발행일</th><th>경과</th></tr></thead>
            <tbody>
              {(data.missingResults||[]).map(e=>(
                <tr key={e.id}>
                  <td><span className="clickable" onClick={()=>navigate(`/product-estimate/new?id=${e.id}`)}>{e.estimate_number}</span></td>
                  <td>{e.receiver_company}</td>
                  <td>{e.project_name}</td>
                  <td>{fmtDate(e.estimate_date)}</td>
                  <td style={{color:'#ef4444',fontWeight:700}}>{daysSince(e.estimate_date)}</td>
                </tr>
              ))}
              {(data.missingResults||[]).length===0 && <tr><td colSpan={5} style={{textAlign:'center',padding:20,color:'#94a3b8'}}>모두 입력 완료</td></tr>}
            </tbody>
          </table>
        </div>

        {/* 세부정보 미입력 고객 — 개인 모드만 */}
        {scope==='personal' && (
        <div className="card">
          <div className="card-header">
            <div className="card-title">세부정보 미입력 고객</div>
            <span className="text-muted">고객 세부정보를 입력해 주세요</span>
          </div>
          <table>
            <thead><tr><th>고객사명</th><th>담당자</th><th>등록일</th><th>견적건수</th><th></th></tr></thead>
            <tbody>
              {(data.incompleteCustomers||[]).map(c=>(
                <tr key={c.id}>
                  <td className="fw-bold">{c.name}</td>
                  <td>{c.contact_name||'-'}</td>
                  <td>{fmtDate(c.created_at)}</td>
                  <td>{c.estimate_count||0}</td>
                  <td><button className="btn btn-outline btn-sm" onClick={()=>navigate('/customers')}>정보 입력</button></td>
                </tr>
              ))}
              {(data.incompleteCustomers||[]).length===0 && <tr><td colSpan={5} style={{textAlign:'center',padding:20,color:'#94a3b8'}}>모두 입력 완료</td></tr>}
            </tbody>
          </table>
        </div>
        )}
      </div>
    </div>
  );
}
